import InstructionsHeader from './InstructionsHeader';

export default InstructionsHeader;
